"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "pianello-val-tidone": {
    "efc34d2c": [{
      "hkey": "3af0fb45",
      "slug": "pianello-val-tidone",
      "name": "Pianello Val Tidone",
      "primary": true,
      "skipSearch": false
    }],
    "castellaro-arcelli": [{
      "hkey": "3af0fb45",
      "slug": "pianello-val-tidone",
      "name": "Pianello Val Tidone",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "f0b930b8": [{
      "hkey": "3af0fb45",
      "slug": "pianello-val-tidone",
      "name": "Pianello Val Tidone",
      "primary": true,
      "skipSearch": false
    }],
    "gabbiano": [{
      "hkey": "3af0fb45",
      "slug": "pianello-val-tidone",
      "name": "Pianello Val Tidone",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "c4a7b7de": [{
      "hkey": "3af0fb45",
      "slug": "pianello-val-tidone",
      "name": "Pianello Val Tidone",
      "primary": true,
      "skipSearch": false
    }],
    "morago": [{
      "hkey": "3af0fb45",
      "slug": "pianello-val-tidone",
      "name": "Pianello Val Tidone",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "2f21e2dd": [{
      "hkey": "3af0fb45",
      "slug": "pianello-val-tidone",
      "name": "Pianello Val Tidone",
      "primary": true,
      "skipSearch": false
    }],
    "roccapulzana": [{
      "hkey": "3af0fb45",
      "slug": "pianello-val-tidone",
      "name": "Pianello Val Tidone",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;